import React from 'react';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import { Chat, Description, NotificationsActive, Groups, Sms } from '@mui/icons-material';

const features = [
  {
    icon: <Chat sx={{ color: '#7C8DB5', fontSize: 28 }} />,
    title: 'Two-Way SMS',
    description: 'Send and receive text messages with customers directly inside Trnsact — no switching apps.',
  },
  {
    icon: <Description sx={{ color: '#7C8DB5', fontSize: 28 }} />,
    title: 'Deal-Linked Threads',
    description: 'Every conversation is tied to a deal, so your team always has full context at a glance.',
  },
  {
    icon: <NotificationsActive sx={{ color: '#E8A038', fontSize: 28 }} />,
    title: 'Real-Time Notifications',
    description: 'Get instant alerts when customers reply, so nothing falls through the cracks.',
  },
  {
    icon: <Groups sx={{ color: '#3B4FA8', fontSize: 28 }} />,
    title: 'Team Visibility',
    description: 'Managers can see all message threads across deals — no more siloed communication.',
  },
];

export const MessagingPromo = () => {
  return (
    <Stack alignItems="center" py={6} px={2} gap={4} maxWidth={700} mx="auto" sx={{ bgcolor: '#f8f9fb' }}>
      <Stack alignItems="center" gap={2}>
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #EDE7F6, #E8EAF6)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Sms sx={{ color: '#9575CD', fontSize: 32 }} />
        </Box>

        <Typography variant="h5" fontWeight={700}>
          Text Messaging
        </Typography>

        <Typography variant="body1" color="text.secondary" textAlign="center" maxWidth={520}>
          Send and receive SMS messages with your customers without ever leaving Trnsact. Keep every conversation tied
          to the deal — visible to your whole team.
        </Typography>
      </Stack>

      <Box display="grid" gridTemplateColumns="1fr 1fr" gap={2} width="100%">
        {features.map(({ icon, title, description }) => (
          <Paper key={title} variant="outlined" sx={{ p: 3, borderRadius: 2 }}>
            <Stack gap={1}>
              {icon}
              <Typography variant="subtitle1" fontWeight={600}>
                {title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {description}
              </Typography>
            </Stack>
          </Paper>
        ))}
      </Box>

      <Paper
        variant="outlined"
        sx={{
          p: 3,
          borderRadius: 2,
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 2,
        }}
      >
        <Stack direction="row" alignItems="center" gap={2}>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: 1,
              bgcolor: '#E3F2FD',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <Sms sx={{ color: '#42A5F5', fontSize: 20 }} />
          </Box>
          <Stack>
            <Typography variant="subtitle2" fontWeight={600}>
              Ready to get started?
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Contact your Account Manager to enable Messaging for your dealership.
            </Typography>
          </Stack>
        </Stack>

        <Button
          variant="contained"
          href="https://trnsact.com/contact/"
          target="_blank"
          rel="noopener noreferrer"
          sx={{ flexShrink: 0 }}
        >
          Contact Us
        </Button>
      </Paper>

      <Typography variant="caption" color="text.secondary">
        Messaging is available as an add-on module for all Trnsact plans.
      </Typography>
    </Stack>
  );
};
